// extracted by mini-css-extract-plugin
export default {"inputWrapper":"SearchForm_inputWrapper__Z3Q8P","searchButton":"SearchForm_searchButton__s3F67"};